import React from 'react';

const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Skills', href: '#skills' },
    { label: 'Released Games', href: '#released-games' },
    { label: 'Game Jams', href: '#game-jams' },
    { label: 'Contact', href: '#contact' },
];

export default function NavBar() {
    const handleClick = (e, href) => {
        e.preventDefault();
        document.querySelector(href)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleLogoClick = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <nav className="sticky top-0 z-40 bg-black/95 border-b border-red-400/30 backdrop-blur-sm">
            <div className="px-4 py-3 flex flex-wrap gap-x-6 gap-y-2 items-center">
            <a
                href="#top"
                onClick={handleLogoClick}
                className="text-red-400 font-bold text-lg mr-4 hover:text-red-300 transition-colors duration-200"
                >
                NF
            </a>
            {navLinks.map(({ label, href }) => (
            <a
                key={href}
                href={href}
                onClick={(e) => handleClick(e, href)}
                className="text-gray-300 hover:text-red-300 text-sm font-medium tracking-wide transition-colors duration-200"
                >
            {label}
                </a>
                ))}
</div>
</nav>
);
}